import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';
import { TypographyColor } from 'shared/newEntities/components/Typography';

type Props = CommonIconProps & {
  label?: string;
  labelColor?: TypographyColor;
};

const DEFAULT_LABEL = 'DOC';
const DEFAULT_LABEL_COLOR = TypographyColor.white;

const FileDocumentIcon: React.FC<Props> = ({
  label = DEFAULT_LABEL,
  labelColor = DEFAULT_LABEL_COLOR,
  svgProps,
  ...restProps
}: Props) => {
  return (
    <BaseIcon
      iconSize={IconSize.XXL}
      {...restProps}
      svgProps={{
        viewBox: '0 0 40 40',
        ...svgProps
      }}
    >
      <path
        d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
        fill={labelColor}
      />
      <text
        x="20"
        y="30"
        textAnchor="middle"
        fill={labelColor}
        fontSize="9"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        {label}
      </text>
    </BaseIcon>
  );
};

export default FileDocumentIcon;
